import { IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import GenericModal from 'components/Dialogs/GenericModal';
import RecurrenceModal from 'components/RecurringPattern/RecurrenceModal';
import { RecurringPatternSummaryStyle, RecurringSummary } from 'components/RecurringPattern/RecurringSummary';
import { globalStackTokensGapMedium } from 'globalStyles';
import RecurringPattern from 'models/recurringPattern';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IConvertToAnnualPlanModalProps {
  //the start date of the task: the repeat pattern starts here
  startDate: Date;
  onClose: () => void;
  onConvert: (pattern: RecurringPattern) => void;
}

const ConvertToAnnualPlanModal = (props: IConvertToAnnualPlanModalProps) => {
  const { t } = useTranslation(['task']);
  const [showRecurrenceModal, setShowRecurrenceModal] = useState<boolean>(false);
  const [pattern, setPattern] = useState<RecurringPattern>(() => {
    const newPattern = new RecurringPattern();
    newPattern.startDate = props.startDate;

    return newPattern;
  });

  return (
    <>
      <GenericModal
        isOpen={true}
        isBlocking={true}
        onClose={props.onClose}
        onSave={() => props.onConvert(pattern)}
        saveDisabled={!pattern.isActive}
        saveButtonText={t('task:ConvertToAnnualPlanModal.Convert')}
        title={t('task:ConvertToAnnualPlanModal.Title')}
        maxWidth={560}
        maxHeight="90vh"
      >
        <IPStack tokens={globalStackTokensGapMedium}>
          <IPStack.Item>
            <IPText>{t('task:ConvertToAnnualPlanModal.Description')}</IPText>
          </IPStack.Item>
          <IPStack.Item>
            <RecurringSummary
              pattern={pattern}
              summaryStyle={RecurringPatternSummaryStyle.edit}
              label={t('task:Repeat.Title')}
              placeholder={t('task:Repeat.Placeholder')}
              onClick={() => setShowRecurrenceModal(true)}
            />
          </IPStack.Item>
          <IPStack.Item>
            <IPText>{t('task:ConvertToAnnualPlanModal.Proceed')}</IPText>
          </IPStack.Item>
        </IPStack>
      </GenericModal>
      {showRecurrenceModal && (
        <RecurrenceModal
          isOpen={showRecurrenceModal}
          isBlocking={true}
          toggleModal={() => setShowRecurrenceModal(false)}
          recurring={pattern}
          changeRecurring={(newPattern) => setPattern(newPattern)}
          initToAuditYear={false}
          showPreventBeforeStart={true}
        />
      )}
    </>
  );
};

export default ConvertToAnnualPlanModal;
